// Pure helpers for picking trays for a bulk label print. The selection is an
// object of tray_id → tray, so a tray stays selected (with its data) while it
// is scrolled away or filtered out by a search. Every helper returns a new
// object — the selection in state is never edited in place.

export const selectionCount = (selected) => Object.keys(selected).length;

/** Drops one tray (e.g. it was just inactivated); unchanged if it wasn't selected. */
export const deselectTray = (selected, trayId) => {
  if (!(trayId in selected)) return selected;
  const { [trayId]: _removed, ...rest } = selected;
  return rest;
};

export const toggleTraySelection = (selected, tray) =>
  tray.tray_id in selected
    ? deselectTray(selected, tray.tray_id)
    : { ...selected, [tray.tray_id]: tray };

export const selectTrays = (selected, trays) => ({
  ...selected,
  ...Object.fromEntries(trays.map((tray) => [tray.tray_id, tray])),
});

export const deselectTrays = (selected, trays) => {
  const ids = new Set(trays.map((tray) => tray.tray_id));
  return Object.fromEntries(Object.entries(selected).filter(([id]) => !ids.has(id)));
};

/** How many of the trays on screen are selected — drives the header checkbox. */
export const loadedSelectionState = (selected, trays) => {
  const count = trays.filter((tray) => tray.tray_id in selected).length;
  if (count === 0) return "none";
  return count === trays.length ? "all" : "some";
};

/** Keeps a selected tray's name current after it is renamed. */
export const refreshSelectedTray = (selected, saved) =>
  saved?.tray_id in selected
    ? { ...selected, [saved.tray_id]: { ...selected[saved.tray_id], ...saved } }
    : selected;

/** Selected trays in barcode order, so labels come out in tray-number order. */
export const traysToPrint = (selected) =>
  Object.values(selected).sort((a, b) => Number(a.barcode) - Number(b.barcode));
